<script>
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'

  export default {
    components: {
      Slick
    },
    props: {
      isEn: {
        type: Boolean,
        default: false
      },
      list: {
        type: Array,
        default: () => {
          return []
        },
      }
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          touchThreshold: 3,
          arrows: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          dots: true,
        },
        noProgress: true,
        slickProgress: 0,
        isPause: false,
        slickSpeed: 8000,
        slickProgressClock: null,
      }
    },
    computed: {
      getSlickList() {
        return this.isEn? [this.list[0]] : this.list
      }
    },
    mounted() {
      const runProgressClock = () => {
        const timeout = 10;
        this.slickProgressClock = setInterval(() => {
          if(!this.isPause) {
            this.slickProgress += 100 / (this.slickSpeed / timeout);

            if(this.slickProgress >= 100) {
              this.slickProgress = 0;
              if(this.$refs.slick) {
                this.onNext();
              }
            }
          }
        }, timeout);
      }

      runProgressClock();
    },
    destroyed() {
      clearInterval(this.slickProgressClock)
    },
    methods: {
      onSlideTo(index) {
        this.$refs.slick.goTo(index - 1)
      },
      onNext() {
        this.$refs.slick.next()
      },
      onPrev() {
        this.$refs.slick.prev()
      },
      onBeforeChange(event, slick, currentSlide, nextSlide) {
        this.slickProgress = 0;
      },
      nlToBr(string) {
        return string && string.replace(/(?:\r\n|\r|\n)/g, '<br>')
      },
      goContact() {
        this.$router.push({
          name: 'contact'
        })
      }
    }
  }
</script>

<template>
  <div :class="$style.SectionBanner">
    <Slick
      ref="slick"
      :options="slickOptions"
      class="SectionBanner__carouselList slick isStyleSlideshow"
      @beforeChange="onBeforeChange"
    >
      <div
        v-for="(item, index) in getSlickList"
        :key="index"
        class="SectionBanner__carouselList__item"
        :class="{ isStyleNoTextBanner: !!item.link }"
      >
        <img :src="item.introimage" alt="" class="SectionBanner__carouselList__img">
        <div 
          class="container"
          :class="{ 'isSmallWidth': list.length > 1 }"
        >
          <div class="SectionBanner__content">
            <h2 v-if="isEn" class="en">Your Best Partner <br> for Enterprise IT Modernization</h2>
            <h2 v-else>{{ item.title }}</h2>
            <p v-if="isEn" class="en d-md-block d-none">
              The Essential Catalyst for Successful Enterprise <br> Resilience and Agile Transformation
            </p>
            <p v-else class="d-md-block d-none" v-html="nlToBr(item.description)"></p>
            <BaseButton
              v-if="isEn"
              class="en isStyleDark isGlass isRadius SectionBanner__btn"
              :class="{
                isStyleNoTitle: !item.title,
              }"
              to="#contact"
              target="_blank"
              @mouseenter="isPause = true"
              @mouseleave="isPause = false"
            ><i class="fa fa-envelope mr-2"></i>CONTACT
            </BaseButton>
            <BaseButton
              v-else-if="item.link"
              class="isStyleDark isGlass isRadius SectionBanner__btn"
              :class="{
                isStyleNoTitle: !item.title,
              }"
              :href="item.link"
              target="_blank"
              @mouseenter="isPause = true"
              @mouseleave="isPause = false"
            >了解更多
              <i class="SectionBanner__btn-icon fal fa-chevron-right"></i>
            </BaseButton>
          </div>
        </div>
      </div>
    </Slick>
    <div
      v-if="list.length > 1"
      :class="$style.navigation"
    >
      <button
        class="navigation__btn navigation__prev"
        @click="onPrev"
        @mouseenter="isPause = true"
        @mouseleave="isPause = false"
      >
        <i class="navigation__icon fal fa-chevron-left"></i>
      </button>
      <button
        class="navigation__btn navigation__next"
        @click="onNext"
        @mouseenter="isPause = true"
        @mouseleave="isPause = false"
      >
        <i class="navigation__icon fal fa-chevron-right"></i>
      </button>
    </div>
    <div class="swiper-pagination">

    </div>
    <div
      v-if="list.length > 1"
      class="SectionBanner__progress"
      :style="{ width: `${slickProgress}%` }">
    </div>
  </div>
</template>


<style lang="scss" module>

  .SectionBanner {
    position: relative;
    :global {
      .SectionBanner {
        &__btn {
          font-size: 1.25rem;
          color: $color-gray-7 !important;
          border: 1px solid $color-gray-7 !important;
          margin-top: auto;
          width: 36% !important;
          margin-bottom: 2.5rem;
          &.isStyleNoTitle {
            @include max-lg {
              margin: auto auto 1rem;
              color: #fff !important;
              border-color: #fff !important;
            }
          }
          @include max-lg {
            margin: 1rem auto 1rem;
          }
          @include max-md {
            font-size: 15px;
            margin-bottom: 0;
            width: auto !important;
            padding: 0 1rem;
            height: 35px;
            line-height: 35px;
          }
        }

        &__btn-icon {
          display: inline;
          width: 20px;
        }
        &__content {
          display: flex;
          flex-direction: column;
          height: 570px;
          color: $color-gray-7;
          justify-content: center;
          padding: 5rem 0 3rem 0;
          @media screen and (max-width: $container + $container-gap * 2) {
            height: 40vw;
            padding: 3rem 0;
          }
          @include max-md {
            margin: 0 auto;
            position: relative;
            z-index: 3;
            padding: 2rem 0;
            height: 50vw;
          }
          @include max-sm {
            padding: 1rem 0;
          }
          & > div {
            width: 100%;

            @include max-lg {
              text-align: center;
            }
          }

          h2 {
            margin-bottom: 2.5rem;
            font-size: 3.75rem;
            font-weight: medium;
            line-height: 1.33;
            letter-spacing: 0.12em;
            // max-width: 30rem;
            @include max-lg {
              margin: 0 auto 1.25rem auto;
              font-size: 5vw;
            }

            @include max-md {
              margin-bottom: 0;
            }
            &.en {
              font-size: 3.15rem;
              letter-spacing: -0.04rem;
              font-weight: 600;
              @include max-lg {
                margin: 0 auto 1.25rem auto;
                font-size: 5vw;
              }

              @include max-md {
                margin-bottom: 0;
              }
            }
          }

          p {
            margin-bottom: 2.75rem;
            font-size: 24px;
            line-height: 1.75;
            letter-spacing: 0.15em;

            @include max-lg {
              text-align: center;
              font-size: 2.5vw;
              margin-bottom: 0;
            }
            &.en {
              letter-spacing: 0;
              font-size: 20px;
              @include max-lg {
                text-align: center;
                font-size: 2.5vw;
                margin-bottom: 0;
              }
            }
          }
        }

        &__carouselList {
          &__item {
            position: relative;
            // background-color: black;
            // .container {
            //   h2, p, a span {
            //     color: white;
            //   }
            //   a {
            //     border-color: white !important;
            //   }
            // }
          }
          &__img {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
            height: 100%;
            width: 100%;
            object-fit: cover;
            @include max-xl {
              object-position: 20%;
            }
            @include max-md {
              object-position: 7%;
            }
          }
        }

        &__progress {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 5px;
          background: $color-primary;
          transition: width 0s;
          // @include max-md {
          //   display: none;
          // }
        }
      }
      .isSmallWidth {
        @media screen and (max-width: $container + $container-gap * 2 + 200) {
          width: 77%;
        }
        @include max-lg {
          width: 90%;
        }
      }
    }
  }

  .navigation {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    pointer-events: none;

    // @include max-md {
    //   display: none;
    // }

    :global {
      .navigation {
        &__btn {
          position: absolute;
          top: 50%;
          z-index: 0;
          display: flex;
          width: calc(((100vw - #{$container-menu}) / 2) + 4rem);
          height: 100%;
          pointer-events: auto;
          background: transparent;
          border: unset;
          transform: translateY(-50%);
          appearance: none;

          @media screen and (max-width: $container-menu) {
            width: 100px;
          }

          &:focus {
            outline: none;
          }

          &:hover {
            .navigation {
              &__icon {
                color: #FFF;
                background: $color-primary;
                border-color: $color-primary;
                opacity: 1;
                @include max-md {
                  color: $color-primary;
                  background: transparent;
                  border-color: transparent;
                  opacity: 1;
                }
              }
            }
          }

          &:active {
            outline: none;

            .navigation {
              &__icon {
                opacity: 0.75;
              }
            }
          }
        }

        &__prev {
          left: 0;
          align-items: center;
          justify-content: flex-end;

          @media screen and (max-width: $container-menu) {
            justify-content: flex-start;
            padding-left: 2rem;
          }
          @include max-md {
            padding-left: 10px;
          }
        }

        &__next {
          right: 0;
          align-items: center;
          justify-content: flex-start;

          @media screen and (max-width: $container-menu) {
            justify-content: flex-end;
            padding-right: 2rem;
          }      
          @include max-md {
            padding-right: 10px;
          }
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 53px;
          height: 53px;
          color: #8C97AB;
          border: unset;
          border: 1px solid #8C97AB;
          border-radius: 100%;
          box-shadow: 0 32px 84px #0E567C2A;
          transition: border 0.3s, color 0.3s, background 0.3s;
          @include max-lg {
            width: 33px;
            height: 33px;
          }
          @include max-md {
            color: #8C97AB;
            border: 0;
            font-size: 20px;
            font-weight: 500;
            box-shadow: 0;
          }
        }
      }
    }
  }
</style>
